import styled from 'styled-components'
import { Layout } from 'antd'

export const StyledLayout = styled(Layout)`
  overflow: hidden;
`

export const StyledLayoutContent = styled(Layout)`
  overflow-y: hidden;
`

export const StyledUpdateButton = styled.div`
  background-color: #1890ff;
  border-color: #1890ff;
  border-radius: 6px;
  color: #fff;
  line-height: 36px;
  width: 120px;
`
